import { call, put, select, takeLatest } from 'typed-redux-saga'
import { errorHandler, loadersSlice, gridSlice } from 'Modules'
import { ResponseCatalog } from 'Models'
import { routerActions } from 'connected-react-router'
import { FrontUrls } from 'Constants/FrontUrls'
import {
	reportApi,
	ReportsModel,
	reportNS,
	reportsSlice,
	reportSelector,
} from 'Pages/advertisement'
import { Deserialize } from 'cerialize'

function* getReportsList(action: reportNS.getReportList) {
	try {
		const { params, clear, callback } = action.payload
		yield* put(gridSlice.actions.setLoading(true))
		if (clear) {
			yield* put(reportsSlice.actions.clearAll())
		}
		const res = yield* call(reportApi.getAll, params)
		const logsResponse = new ResponseCatalog<ReportsModel>(res)
		logsResponse.entries = logsResponse.entries.map(
			(log): ReportsModel => Deserialize(log, ReportsModel)
		)
		if (!clear) {
			const oldLogs = yield* select(reportSelector.selectReportsEntries)
			logsResponse.entries = [...oldLogs, ...logsResponse.entries]
		}
		yield* put(reportsSlice.actions.setAll(logsResponse))
		yield* put(reportsSlice.actions.setRequestParams(params))
		callback?.()
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(gridSlice.actions.setLoading(false))
	}
}

function* getReportsOne(action: reportNS.GetReports) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const res = yield* call(reportApi.getOne, action.payload)
		yield* put(reportsSlice.actions.setOne(res))
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}
function* createReports(action: reportNS.CreateReport) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const res = yield* call(reportApi.createOne, action.payload)
		yield* put(reportsSlice.actions.setOne(res))
		yield* put(routerActions.push(FrontUrls.advertisment.index))
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

function* creatCalculate(action: reportNS.GetCalculate) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		yield* put(reportsSlice.actions.setAwaitAutomation(true))
		const { params } = action.payload
		const res = yield* call(reportApi.createCalculate, params)
		yield* put(reportsSlice.actions.setCalculate(res))
		yield* put(reportsSlice.actions.setAwaitAutomation(false))
	} catch (error) {
		yield* put(reportsSlice.actions.setAwaitAutomation(false))
		yield* call(errorHandler, error)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

export function* createAutogenerate(action: reportNS.GetAutogenerate) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const { data } = action.payload
		yield* call(reportApi.createAutomation, data)
		yield* put(routerActions.push(FrontUrls.advertisment.index))
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

function* updateReports(action: reportNS.UpdateReports) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const { id, data } = action.payload
		const res = yield* call(reportApi.updateOne, id, data)
		yield* put(reportsSlice.actions.setOne(res))
		yield* put(routerActions.push(FrontUrls.advertisment.index))
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}
export function* reportSaga() {
	yield* takeLatest(reportsSlice.actions.getAll.type, getReportsList)
	yield* takeLatest(reportsSlice.actions.getOne.type, getReportsOne)
	yield* takeLatest(reportsSlice.actions.createOne.type, createReports)
	yield* takeLatest(reportsSlice.actions.getCalculate.type, creatCalculate)
	yield* takeLatest(reportsSlice.actions.getAutogenerate.type, createAutogenerate)
	yield* takeLatest(reportsSlice.actions.updateOne.type, updateReports)
}
